module.exports = __webpack_public_path__ + "static/fonts/NotoSansKR-Regular-Hestia.a9bdbc9.otf";